import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  useTheme
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';

const DeleteConfirmDialog = ({ open, onClose, onConfirm, fileName, loading = false }) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '16px',
          p: 1
        }
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <WarningIcon sx={{ color: theme.palette.error.main, fontSize: '1.5rem' }} />
          <Typography variant="h6" component="span" fontWeight={600}>
            确认删除文件
          </Typography>
        </Box>
      </DialogTitle>
      
      <DialogContent sx={{ py: 2 }}>
        <Typography variant="body1" sx={{ mb: 2 }}>
          您确定要立即删除任务文件吗？
        </Typography>
        
        {fileName && (
          <Box sx={{ 
            bgcolor: 'rgba(0,0,0,0.04)', 
            p: 2, 
            borderRadius: '8px',
            mb: 2
          }}>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
              文件名：
            </Typography>
            <Typography variant="body2" fontWeight={500}>
              {fileName}
            </Typography>
          </Box>
        )}
        
        <Box sx={{ 
          bgcolor: 'rgba(255, 193, 7, 0.1)', 
          p: 2, 
          borderRadius: '8px',
          border: '1px solid rgba(255, 193, 7, 0.3)'
        }}>
          <Typography variant="body2" color="warning.dark">
            我们严格保护您的数据隐私，您可随时自主删除，删除操作不可撤销，文件将无法恢复，仅保留必要的任务记录。
          </Typography>
        </Box>
      </DialogContent>
      
      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          disabled={loading}
          sx={{ 
            borderRadius: '12px',
            minWidth: '80px'
          }}
        >
          取消
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          disabled={loading}
          sx={{ 
            borderRadius: '12px',
            minWidth: '80px'
          }}
        >
          {loading ? '删除中...' : '确认删除'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmDialog;